
import _ from "lodash";
//import { App, plugin } from '@inertiajs/inertia-vue'
import RuntimeTemplateCompiler from "vue-runtime-template-compiler"
import $ from 'jquery'

window.Vue = require('vue').default;
window.$ = $;

window.Vuex = require('vuex');


var LangJs = require('./../Library/LangJs/Lang.js')

var messages = require('../../../../public/messages.json');
window.Lang = new LangJs({
    locale:window.appSettings.appLanguage,
    fallback:window.appSettings.appLanguageFallback,
    messages: messages
});


window.axios = require('axios');

window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest'
};

window.axios.interceptors.response.use(function(response) {
    return response;
}, function(error) {
    if (error && error.response && error.response.status) {
        if (401 === error.response.status) {
           // window.location=window.app.$page.props.urls.home
        } 
        
        if (403 === error.response.status) {
           // window.location=window.app.$page.props.urls.home
        } else {
            return Promise.reject(error);
        }
    } else {
        return Promise.reject(error);
    }

});

//Vue.use(plugin)
Vue.use(Vuex)
Vue.use(RuntimeTemplateCompiler)

  window.moment = require('moment-timezone');
moment.locale(window.appSettings.appLanguage);
moment.tz.setDefault("Europe/Berlin");

window.chatStore = new Vuex.Store({
    name:'chat-store',
    state:{

        votingEnabled:false,
        speedDatingActive:false,
        speedDatingLastUser:null,
        speedDatingCurrentRequest:null,
        speedDatingCurrentChat:null,
        notifications:[],
        onlineStatuses:{},
        chats:[],
        chatSideBarVisible:false,
        openChats:{},
        openChat:null,
        contacts: null,
        user: null,
        eventData: null,
        favEventItems:[],
        votes:[],
        eventItems:{},
        exhibitors:[],
        viewedPosters:[],
        program:{},
        messagePagination:{},
        loadingIndicators:{},
        eventParticipants:[],
        forumChannels:[],
        forumThreads:{},
        zoomMeetings:[],
        liveStreams:[],
        videoChatRooms:[],
        presentUsers:[],
        receivePresenceUpdates:false,
        currentVideoChatRoom:null,
    },
    getters: {
        favEventItemsObjects: state => {
            return state.eventItems.filter(eventItem => state.favEventItems.includes(eventItem.id)).sort(function(a, b) {
                return a.timestamp - b.timestamp;
            })
        },
        chatUnreadCount: state => {
            var unreadCount={}
            state.chats.forEach((chatItem)=>{
                unreadCount[chatItem.id]=chatItem.messages.filter(message=>message&&message.id&&(message.is_seen!=1 && message.is_seen!=true)).length
            })
            return unreadCount
        },
        posterRooms: state => {
            if(!state.program || !state.program.sessions){
                return {}
            }
            return _.sortBy(_.filter(state.program.sessions,{'virtual_poster_room': true}),'shortRecordName')
        }
    },

    mutations:{
        setZoomMeetings(state, channels) {
            Vue.set(state,'zoomMeetings',channels.zoomMeetings)
            Vue.set(state,'liveStreams',channels.liveStreams)
        },
        removePresenceUser(state, user) {
            let index = state.presentUsers.findIndex(item => item.id ===user.id )
            if (index !== -1) {
                state.presentUsers.splice(index, 1);
            }

        },
        addPresenceUser(state, user) {
            state.presentUsers.push(user)

        },
        setStartRoomsOfPresenceUsers(state, channelsObject) {
            for(const [key, value] of Object.entries(channelsObject)){
                if(value.length>0){
                    value.forEach( (userId)=> {
                        let index = state.presentUsers.findIndex(item => item.id ===userId)
                        if (index !== -1) {
                            state.presentUsers[index].room=key;
                        }
                    });
                }
            }


        },
        setForumChannels(state, channels) {
            Vue.set(state,'forumChannels',channels)
        },
        setEventParticipants(state, channels) {
            Vue.set(state,'eventParticipants',channels)
        },

        setProgram(state, program) {
            Vue.set(state,'program',program)
        },

        setVideoChatRooms(state, videoChatRooms) {
            Vue.set(state,'videoChatRooms',videoChatRooms)
        },

        setOnlineStatuses(state, statuses) {
            Vue.set(state,'onlineStatuses',statuses)
        },

        setAllMessagesRead(state, chatId){
            //console.log("Marking Messages as read",chatId)
            if(state.chats){
                let chatTemp=state.chats.findIndex((chat)=>{return chat && chat.id==chatId})
                console.log("Marking Messages as read INDEX",chatTemp)
                if(chatTemp!="-1"){

                    console.log("Marking Messages as read")
                    //  let messages = chatTemp.messages
                    var foundUnread=false
                    state.chats[chatTemp].messages.forEach((item, index) =>{
                        if(state.chats[chatTemp].messages[index] && (state.chats[chatTemp].messages[index].is_seen!=1 && state.chats[chatTemp].messages[index].is_seen!=true)){
                            state.chats[chatTemp].messages[index].is_seen = 1;
                            foundUnread=true
                            // console.log("Marking Message as read",messages[index])
                        }
                    });
                    if(foundUnread){
                        window.axios.post('/api/chat/markAsRead/'+chatId,{}).then((data)=>{

                        }).catch((e)=>{})

                    }

                }


                //   Vue.set(state.chats[chatId],'messages',messages)


            }
        },


        setMessagePagination(state, data) {
            data.data.data=null
            Vue.set(state.messagePagination,data.chatId,data.data)
        },
        setLoadingIndicator(state, data) {

            Vue.set(state.loadingIndicators,data.chatId,data.data)
        },
        setExhibitors(state, exhibitors) {
            Vue.set(state,'exhibitors',exhibitors)

        },
        setEventItems(state, eventItems) {
            Vue.set(state,'eventItems',eventItems)
        },
        openChat (state, chatId) {
            console.log("[CHAT] Open Chat",chatId)
            if(chatId.id){
                chatId=chatId.id
            }
            Vue.set(state,'openChat', chatId)

        },
        closeChat (state, chatId=null) {

            Vue.set(state,'openChat',null)
        },
        setChats (state, chats) {
            chats.forEach((item) => {
                this.commit("addChat", item);
            });


        },
        mergeChats (state, chats) {
            state.chats = _.merge(state.chats,chats)
        },
        addChatMessage (state, message) {

            if(message && !message.message_id){
                message.message_id=message.id
            }
            if(state.chats){
                if(message && this.state.openChat==message.conversation_id){
                    message.is_seen=1
                    console.log("[ADD MESSAGE] Chat is opened")
                }

                //  message.is_sender = (state.user.id == message.messageable_id && state.user.type == message.messageable_type) || (message.participation && state.user.id == message.participation.messageable_id && state.user.type == message.participation.messageable_type)
                let chatTemp=state.chats.find((chat)=>{return chat.id==message.conversation_id})
                if(chatTemp){
                    let messageExists = chatTemp.messages.findIndex((messageItem)=>{return messageItem && messageItem.message_id==message.message_id})
                    console.log("FOUND CHAT MESG INDEX",messageExists)
                    if(messageExists!="-1"){

                        //   chatTemp.messages[messageExists]=message
                    }else{
                        chatTemp.messages.push(message)
                    }
                    chatTemp.messages= chatTemp.messages.filter(item=>item && item.message_id).sort((a,b)=>a.message_id-b.message_id)
                    window.chatBus.$emit('chat-delete-typing-'+message.conversation_id,message)
                }else{
                    window.chatBus.$emit('forceGetChats')
                }



                /*
                state.chats.forEach((chat)=>{

                    if(chat.id==message.conversation_id){
                        message.is_sender = (state.user.id == message.messageable_id && state.user.type == message.messageable_type)
                        chat.messages.push(message)

                    }
                })

                */
            }

        },
        addChat (state, chat) {

            if(state.chats){


                let chatIndex=state.chats.findIndex((chatItem)=>{return chatItem.id==chat.id})
                if(chatIndex!=-1){
                    let tempChat=state.chats[chatIndex]
                    chat.messages=tempChat.messages
                    Vue.set(state.chats,chatIndex,chat)
                }else{
                    if(!chat.messages){
                        chat.messages=[]
                    }
                    state.chats.push(chat)
                }



                /*
                state.chats.forEach((chat)=>{

                    if(chat.id==message.conversation_id){
                        message.is_sender = (state.user.id == message.messageable_id && state.user.type == message.messageable_type)
                        chat.messages.push(message)

                    }
                })

                */
            }

        },

        addNotification(state, notification) {

            if(state.notifications){


                let notificationIndex=state.notifications.findIndex((notificationItem)=>{return notificationItem.id==notification.id})
                if(notificationIndex!=-1){

                    Vue.set(state.notifications,notificationIndex,notification)
                }else{

                    state.notifications.unshift(notification)
                }



                /*
                state.chats.forEach((chat)=>{

                    if(chat.id==message.conversation_id){
                        message.is_sender = (state.user.id == message.messageable_id && state.user.type == message.messageable_type)
                        chat.messages.push(message)

                    }
                })

                */
            }

        },

        markNotificationAsRead(state, notification) {

            if(state.notifications){
                var notificationId = null
                if(notification.id){
                    notificationId=notification.id
                }else{
                    notificationId=notification
                }

                let notificationIndex=state.notifications.findIndex((notificationItem)=>{return notificationItem.id==notificationId})
                if(notificationIndex!=-1){

                    Vue.set(state.notifications[notificationIndex],'read_at', Date.now())
                    Vue.set(state.notifications[notificationIndex],'created_at', notification.created_at)
                }
            }

        },
        markAllNotificationsAsRead(state, notification) {

            if(state.notifications){


                Vue.set(state,'notifications', [])


            }

        },
        setNotifications(state, notifications) {

            state.notifications=notifications

        },
        setFavs(state, favs) {
            Vue.set(state,'favEventItems',favs)
        },
        setVotes(state, favs) {
            Vue.set(state,'votes',favs)
        },
        setViewedPosters(state, favs) {
            Vue.set(state,'viewedPosters',favs)
        },
        removeFav(state, fav) {

            if(state.favEventItems){

                let favEventItemTemp=state.favEventItems.find((favEventItem)=>{return favEventItem==fav})
                if(favEventItemTemp!="-1"){
                    let favEventItemExists = state.favEventItems.findIndex((favEventItemItem)=>{return favEventItemItem==fav})
                    console.log("FOUND CHAT MESG INDEX",favEventItemExists)
                    if(favEventItemExists!="-1"){
                        Vue.delete(state.favEventItems,favEventItemExists)
                    }
                }

            }

        },
        removeVote(state, fav) {

            if(state.votes){

                let favEventItemTemp=state.votes.find((favEventItem)=>{return favEventItem==fav})
                if(favEventItemTemp!="-1"){
                    let favEventItemExists = state.votes.findIndex((favEventItemItem)=>{return favEventItemItem==fav})
                    console.log("FOUND CHAT MESG INDEX",favEventItemExists)
                    if(favEventItemExists!="-1"){
                        Vue.delete(state.votes,favEventItemExists)
                    }
                }

            }

        },
        addFav(state, fav) {

            if(state.favEventItems){

                let favEventItemTemp=state.favEventItems.find((favEventItem)=>{return favEventItem==fav})
                if(favEventItemTemp!="-1"){
                    let favEventItemExists = state.favEventItems.findIndex((favEventItemItem)=>{return favEventItemItem==fav})
                    console.log("FOUND CHAT MESG INDEX",favEventItemExists)
                    if(favEventItemExists!="-1"){
                        state.favEventItems[favEventItemExists]=fav
                    }else{
                        state.favEventItems.push(fav)
                    }
                }

            }

        },
        addVote(state, fav) {

            if(state.votes){

                let favEventItemTemp=state.votes.find((favEventItem)=>{return favEventItem==fav})
                if(favEventItemTemp!="-1"){
                    let favEventItemExists = state.votes.findIndex((favEventItemItem)=>{return favEventItemItem==fav})
                    console.log("FOUND CHAT MESG INDEX",favEventItemExists)
                    if(favEventItemExists!="-1"){
                        state.votes[favEventItemExists]=fav
                    }else{
                        state.votes.push(fav)
                    }
                }

            }

        },

        setContacts (state, contacts) {
            state.contacts = contacts
        },
        setUser (state, user) {
            Vue.set(state,'user',user)

        },
        setEventData (state, eventData) {
            state.eventData = eventData
        }
    }
})
Vue.component('global-loader', require('../components/public/conference/Global-Loader.vue').default);

const el = document.getElementById('app')

Vue.mixin({

    methods: {
        getDateObject(dateString) {
            return window.moment(dateString);
          },
        trimHtmlField(str){

            if ((str===null) || (str==='')){
                return false;
            }else{
                str = str.toString();
                str= str.replace(/<[^>]*>/g, '');
                str=str.trim()
                return str !=""
            }
            

        },
        translateField(data){
            var appLanguage = window.appSettings.appLanguage
            if (typeof data === 'undefined' || data === null) {
                return '';
            }
            if (typeof data[appLanguage] !== 'undefined') {
                return data[appLanguage];
            }
            if (typeof data['A0'] !== 'undefined') {
                return data['A0'];
            }
          /*  if (typeof data[this.mainLanguage] !== 'undefined') {
                return data[this.mainLanguage];
            }*/
            if (typeof data !== 'object') {
                return data;
            }
    
            return ''
        },
        translate(translateString) {

            let translation = window.Lang.get(translateString)
            if(!translation){
                
            }

            return translation ?? translateString
        },

        getObjectLength(objectvar) {
            return _.keys(objectvar).length
        },
    }})

import ICountUp from 'vue-countup-v2';
import Vuex from "vuex";
import Vue from "vue";
Vue.component('up-counter', require('./widgets/UpCounter.vue').default);

Vue.component('event-detail-booking', require('./widgets/EventDetailBooking.vue').default);


Vue.component('event-calendar', require('./widgets/EventCalendar.vue').default);
Vue.component('schedule-extended', require('./widgets/schedule_browser/src/App.vue').default);
Vue.component('events-browser', require('./widgets/events-browser/src/components/EventBrowser.vue').default);


Vue.component('custom-plugin-element', require('./widgets/CustomElement.vue').default);



window.widgets=new Vue({
    el: '#crm__widgets',
    components:{ICountUp},
    store:window.chatStore,
    data(){
        return {
            temp:{},
            globalLoading: false}
    },
    methods:{
        setVariable(name,value){

                this.$data[name]=value

        },
        getVariable(name){
            if(this.$data[name]){
               return this.$data[name]
            }
            return false
        }
    }
})
